<template>
  <div class="reserve">
    <div class="com-content" v-for="(item,index) in prizeList" :key="index">
      <div class="left">
        <img class="left" :src="item.prizeImg" alt="" />
      </div>
      <div class="right">
        <div class="name">{{item.prizeName}}</div>
        <div class="number-box">
          <div class="number">库存： {{item.inventory}}</div>
          <div class="number">剩余库存： 123</div>
        </div>
        <div>兑换条件：无忧签</div>
        <div class="button-box">
          <span class="edit" @click="editPrize(item,index)">编辑</span>
          <span>删除</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    prizeList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  watch: {
    prizeList: {
      handler(newValue, oldValue){
        this.newInfo = newValue
      },
      deep:true,
      immediate: true    
    },
  },
  methods: {
    editPrize(item,index) {
      this.$emit('editPrize', item, index)
    }
  }
}
</script>

<style lang="stylus" scoped>
.reserve {
  margin: 15px 0;
  .reserve-title {
    padding: 0 15px
    font-size: 14px;
    font-weight: bold;
    color: #303133;
  }
  .com-content {
    display: flex;
    margin 10px 15px
    padding 6px
    background-color: #fff
    border-radius: 8px;
    .left {
      width: 100px;
      height: 100px;
      background: #ccc;
    }
    .right {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-left: 10px;
      flex: 1;
      .name {}
      .number-box {
        display: flex;
        justify-content: space-between;
      }
      .button-box {
        display: flex;
        justify-content: flex-end;
        color: #ff6b31;
        .edit {
          margin-right: 10px;
        }
      }
    }
  }
}
</style>